import { render } from "./CollectionView.vue?vue&type=template&id=d882b73a&scoped=true"
import script from "./CollectionView.vue?vue&type=script&lang=js"
export * from "./CollectionView.vue?vue&type=script&lang=js"

import "./CollectionView.vue?vue&type=style&index=0&id=d882b73a&scoped=true&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d882b73a"]])

export default __exports__